import React from 'react';
import { Link } from 'react-router-dom';
import { ListGroup, Container, Row, Col, Navbar, Nav } from 'react-bootstrap';

const Activity = () => {
  return (
    <Container fluid>
      <h2>Activity Log</h2>
    </Container>
  );
};

export default Activity;
